import React from 'react';

import { find } from 'lodash';
import { COVERAGE_TYPE } from 'src/people/const';
import dayjs from 'dayjs-ext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import propTypes from 'prop-types';
import { UiTable, startsWithCaseInsensitive } from '../../ui';
import { DATE_SMONTH_DAY_SYEAR } from '../../ui/const';

// eslint-disable no-unused-expressions
/* eslint-disable react/prop-types */
export function InsuranceTable({ data, onRowSelection, type }) {
  const tableColumns = [
    {
      Header: 'Name',
      accessor: 'name',
      filterable: true,
      filterMethod: startsWithCaseInsensitive,

      Cell: row => <div className="has-text-centered">{row.value}</div>,
    },
    {
      Header: 'Account',
      accessor: 'account',
      filterable: true,
      filterMethod: startsWithCaseInsensitive,

      Cell: row => <div className="has-text-centered">{row.value}</div>,
    },
    {
      Header: 'Group',
      accessor: 'group',
      filterable: true,
      filterMethod: startsWithCaseInsensitive,

      Cell: row => <div className="has-text-centered">{row.value}</div>,
    },
    {
      Header: 'Coverage Type',
      accessor: 'coverage',
      filterable: false,
      Cell: row => (
        <div className="has-text-centered">
          {row.value
            ? find(COVERAGE_TYPE, {
                value: row.value,
              }).label
            : null}
        </div>
      ),
    },
    {
      Header: 'Family Size',
      accessor: 'familySize',
      Cell: row => <div className="has-text-centered">{row.value}</div>,
      width: 150,
    },
    {
      Header: 'Last Submit',
      accessor: 'lastSubmit',
      Cell: row => (
        <div className="has-text-centered">
          {row.value ? dayjs(row.value).format(DATE_SMONTH_DAY_SYEAR) : null}
        </div>
      ),
      width: 80,
      filterable: false,
    },
    {
      Header: 'User Marked Complete',
      accessor: 'insuranceInformationMarkedComplete',
      Cell: row => (
        <div className="has-text-centered">
          {row.value ? (
            <FontAwesomeIcon icon={['fal', 'check']} color="green" />
          ) : (
            <FontAwesomeIcon icon={['fal', 'minus-circle']} color="red" />
          )}
        </div>
      ),
      width: 80,
      filterable: false,
    },
    {
      Header: 'Select',
      accessor: 'id',
      filterable: false,
      sortable: false,
      resizable: false,
      width: 50,
      Cell: ({ row }) => (
        <div className="has-text-centered">
          <button
            onClick={() => onRowSelection(row._original)}
            className="transparent-elipses"
          >
            {type === 'submit' ? (
              <span className="icon has-text-danger">
                <FontAwesomeIcon icon={['fas', 'minus-circle']} size="lg" />
              </span>
            ) : (
              <span className="icon has-text-green">
                <FontAwesomeIcon icon={['fas', 'plus-circle']} size="lg" />
              </span>
            )}
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <UiTable
        className="transactions-table -striped -highlight"
        columns={tableColumns}
        data={data}
        useTablePagination
        pageSize={type === 'submit' ? 5 : 10}
        resolveData={data =>
          data.map(transaction => ({
            ...transaction,
          }))
        }
        getTheadThProps={(_state, _rowInfo, column) => {
          if (column.id === 'amount') {
            return { className: 'has-text-right' };
          }
          if (column.id !== 'date') {
            return { className: 'has-text-left' };
          }
          return { className: '' };
        }}
        SubComponent={row => {
          return (
            <div style={{ padding: '20px', background: 'inherit' }}>
              <UiTable
                data={row.original.familyMembers}
                title="Insurance sub table"
                columns={[
                  {
                    Header: 'Name',
                    accessor: 'name',
                    sortable: false,
                    Cell: row => (
                      <div className="has-text-centered">{row.value}</div>
                    ),
                  },

                  {
                    Header: 'Relationship',
                    accessor: 'relationship',
                    Cell: row => (
                      <div className="has-text-centered">
                        {row.value === 'Legal_Dependent'
                          ? 'Legal Dependent'
                          : row.value}
                      </div>
                    ),
                    sortable: false,
                  },
                ]}
                showPagination={false}
                hideButton
                hideNext
                hidePrev
              />
            </div>
          );
        }}
        title="Transaction"
        filterable
        hideButton
        hideNext
        hidePrev
      />
    </>
  );
}

InsuranceTable.propTypes = {
  data: propTypes.arrayOf(propTypes.object).isRequired,
  onRowSelection: propTypes.func.isRequired,
  type: propTypes.string.isRequired,
};
